import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *已投票成员列表
 * @param params
 * 
*/

export const voteList = params => Http.get(`${baseUrl}/activity/vote`, { params })
